import React from "react";
import { MessageCircle, Send, Clock } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export default function Contact() {
  const { settings } = useStore();
  const s = settings || {};
  return (
    <div className="px-4 py-6">
      <h1 className="font-heading font-black uppercase text-3xl text-[#F0EDEA] mb-6">Contact Us</h1>
      <div className="bg-[#1C1C1C] border border-[#333] rounded-2xl p-6 space-y-4">
        <p className="text-[#A8A2A0]">Reach out on Signal or Telegram to place an order or ask a question.</p>
        <a href={s.signal_link || "#"} target="_blank" rel="noreferrer" className="btn-skew btn-primary w-full" data-testid="contact-signal"><span><MessageCircle size={18} /> Message on Signal</span></a>
        <a href={s.telegram_link || "#"} target="_blank" rel="noreferrer" className="btn-skew btn-secondary w-full" data-testid="contact-telegram"><span><Send size={18} /> Message on Telegram</span></a>
        <div className="flex items-center gap-3 pt-2 text-[#F0EDEA]">
          <Clock size={20} className="text-[#E60000]" />
          <span className="whitespace-pre-line">{s.hours || "Mon-Sun: 10AM - 10PM"}</span>
        </div>
      </div>
    </div>
  );
}
